export interface DocumentTypeCategory {
  category: string;
  types: string[];
}

export const DOCUMENT_TYPE_TAXONOMY: DocumentTypeCategory[] = [
  {
    category: 'Passport',
    types: [
      'Current Passport',
      'Previous Passport',
      'Cancelled Indian Passport',
      'Indian Passport of Applicant',
      'Current Passport of Applicant',
      'Current Passport – All Pages',
      'Current Passport of Spouse',
      'Parents Current Passport',
      'Indian Passport of Both Parents',
      "Kid's Passport Pages",
      'Passport of Relative Living in USA',
      'Passport of Relative Living in UK',
      'Passport of Relative Living in Schengen Area',
      'Arrival Stamp on Passport',
    ],
  },
  {
    category: 'Visa & Immigration',
    types: [
      'Existing US Visa',
      'Indian Visa',
      'Previous Visa Stamping',
      'Visa Stamping / Approved I-797',
      'Visa Stamping / OCI Card',
      'H1/H4 Approval Notice',
      'Approved Notice for I-130',
      'OCI Card',
      'OCI Card of Family Member',
      'PIO Card',
      'Green Card',
      'Spouse Green Card',
      'Previous EAD',
    ],
  },
  {
    category: 'Address Proof',
    types: [
      'Address Proof',
      'US Address Proof',
      'Indian Address Proof',
      'UK Address Proof',
      'Address Proof from Home Country',
      "Parent's Address Proof",
    ],
  },
  {
    category: 'Birth / Marriage / Certificates',
    types: [
      'Birth Certificate',
      'Apostilled Birth Certificate',
      "Applicant's Birth Certificate",
      'Birth Certificate of Each Child',
      'Marriage Certificate',
      "Parent's Marriage Certificate",
      'Death Certificate',
      'Citizenship Certificate',
      'Naturalization Certificate',
      'Spouse’s Naturalization Certificate',
      'Naturalization Certificate for Relative in USA',
      'Naturalization Certificate of Parents',
      'Renunciation/Surrender Certificate',
      'Reservation Certificate',
      'TDS Certificate',
    ],
  },
  {
    category: 'Employment & Invitation Letters',
    types: [
      'Employment Letter',
      'Sponsorship Letter from Company',
      'Business Letter from USA Company',
      'Business Letter from Canadian Company',
      'Business Letter from USA/Canadian Company',
      'Invitation Letter from India',
      'Invitation Letter by Host Company from Europe',
      'Letter with Reason for Emergency Certificate',
    ],
  },
  {
    category: 'Legal Status',
    types: [
      'Legal Status in USA',
      'Legal Status in Canada',
      'Parents Legal Status in USA',
    ],
  },
  {
    category: 'Identity Cards',
    types: [
      'PAN Card',
      'Previous PAN Card',
      'PAN Card of Indian Company',
      'Aadhar Card',
      'Aadhar Card of Parents',
      'Driving License',
      'Election ID Card',
      'Copy of Pension Card / Pension Book',
    ],
  },
  {
    category: 'Financial Documents',
    types: [
      'Bank Account Statement',
      'NRE Account',
      'NRO Account',
      'Income Documents',
      'ITR with Computation',
      'Investment Account Statement',
      'Pay Slips',
      'Deductions',
      'Donation Receipts',
      'Medi Claim Document',
      '15CA/CB',
    ],
  },
  {
    category: 'Company Documents',
    types: [
      'Company Incorporation Document for Indian Company',
      'Company Incorporation Document for Canadian Company',
      'Company Incorporation Document for USA/Canadian Company',
    ],
  },
  {
    category: 'Educational Documents',
    types: ['10th Class Mark Sheet'],
  },
  {
    category: 'Relationship & Family Documents',
    types: [
      'Proof of Relationship',
      'Divorce Decree',
      'Indian Origin Proof',
      'I-129 of Spouse',
      'I-140 of Spouse',
      'Student/Dependent Proof',
    ],
  },
  {
    category: 'Travel Documents',
    types: [
      'Flight Tickets (Round Trip)',
      'Flight Ticket to India',
      'Hotel Bookings',
      'Itinerary Copies',
      'Travel Health Insurance',
      'Proof of Vaccination',
    ],
  },
  {
    category: 'Medical Documents',
    types: ['Certificate from Medical Practitioner'],
  },
  {
    category: 'Legal & Supporting Documents',
    types: ['Name Change Document', 'Police Report', 'Power of Attorney'],
  },
  {
    category: 'Photo & Signature',
    types: ['Photo', 'Applicant Photo', 'Signature or Thumbprint'],
  },
  {
    category: 'Other Documents',
    types: ['Additional Documents'],
  },
];

export const DOCUMENT_CATEGORIES = DOCUMENT_TYPE_TAXONOMY.map(
  (c) => c.category,
);

export const getDocumentTypesForCategory = (
  category?: string | null,
): string[] => {
  if (!category) return [];
  const match = DOCUMENT_TYPE_TAXONOMY.find((c) => c.category === category);
  return match ? match.types : [];
};
